import { SnackbarComponent } from './SnackbarComponent'
import type { GapSnackbarAction } from './GapSnackbar'
import { reactRender } from 'reusable/react-render/react-render'
import variables from 'variables/variables'

export interface SnackbarOptions {
   /** text that will appear on the snackbar */
   title: string
   autoHideDuration?: number | null
   variant?: 'success' | 'warning' | 'error' | 'info'
   actions?: GapSnackbarAction[]
}

/**
 * shows a snackbar to the user. Useful for non-obstrusive updates like 'entity was saved successfully)
 * @param options snackbar options
 */
export function snackbar(options: SnackbarOptions) {
   reactRender((container, root) =>
      <SnackbarComponent container={container} root={root} {...options} />
   )
}

/**
 * shows a successful snackbar to the user. Useful for non-obstrusive updates like 'entity was saved successfully)
 * @param options snackbar options
 */
export function snackbarSuccess(
   title: string,
   { ...options }: Omit<SnackbarOptions, 'variant' | 'title'> = {}
) {
   return snackbar({ ...options, variant: 'success', title })
}

/**
 * shows a error snackbar to the user. Useful for non-obstrusive error messages
 * @param options snackbar options
 */
export function snackbarError(
   title: string,
   { ...options }: Omit<SnackbarOptions, 'variant' | 'title'> & { error?: any } = {}
) {
   if (options.error && (variables.stage.startsWith('dev') || variables.stage.startsWith('test'))) {
      console.error(options.error.message || options.error)
   }
   return snackbar({ ...options, variant: 'error', title })
}

/**
 * shows a info snackbar to the user. Useful for non-obstrusive messages
 * @param options snackbar options
 */
export function snackbarInfo(
   title: string,
   { ...options }: Omit<SnackbarOptions, 'variant' | 'title'> = {}
) {
   return snackbar({ ...options, variant: 'info', title })
}
/**
 * shows a warning snackbar to the user. Useful for non-obstrusive warning messages
 * @param options snackbar options
 */
export function snackbarWarning(
   title: string,
   { ...options }: Omit<SnackbarOptions, 'variant' | 'title'> = {}
) {
   return snackbar({ ...options, variant: 'warning', title })
}
